import React from "react";

const ProductUpsellIcon = ({ hover }: { hover?: boolean }) => {
  if (hover) {

    return (
      <svg width="128" height="59" viewBox="0 0 128 59" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_15299_29100)">
          <rect x="9" y="6.5" width="29" height="29" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
          <rect x="42.5" y="17" width="37" height="3" rx="1.5" fill="#DADEE6" />
          <rect x="42.5" y="22" width="28.1522" height="3" rx="1.5" fill="#DADEE6" />
          <rect x="96" y="16.5" width="23" height="9" rx="4.5" fill="#1879B9" stroke="#1879B9" />
          <rect x="9" y="39.5" width="110" height="9" rx="4.5" stroke="#9EA7B6" />
        </g>
        <defs>
          <filter id="filter0_d_15299_29100" x="0.5" y="0" width="127" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15299_29100" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15299_29100" result="shape" />
          </filter>
        </defs>
      </svg>

    );
  }

  return (
    <svg width="128" height="59" viewBox="0 0 128 59" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_15299_29100)">
        <rect x="9" y="6.5" width="29" height="29" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
        <rect x="42.5" y="17" width="37" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="42.5" y="22" width="28.1522" height="3" rx="1.5" fill="#DADEE6" />
        <rect x="96" y="16.5" width="23" height="9" rx="4.5" fill="#FCFDFF" stroke="#9EA7B6" />
        <rect x="9" y="39.5" width="110" height="9" rx="4.5" stroke="#9EA7B6" />
      </g>
      <defs>
        <filter id="filter0_d_15299_29100" x="0.5" y="0" width="127" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.415686 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15298_1214" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15298_1214" result="shape" />
        </filter>
      </defs>
    </svg>


  );
};

export default ProductUpsellIcon;
